import React, { useState, useEffect, useContext, useCallback } from 'react'
import { useStore, useDispatch } from 'react-redux'
import { Editor } from "react-draft-wysiwyg";
import { EditorState, convertToRaw } from 'draft-js';
import { Loader, Modal, Panel } from 'rsuite';
import { FaDownload } from 'react-icons/fa'
import { IoRecordingOutline } from 'react-icons/io5'
import draftToHtml from 'draftjs-to-html';
import { AiOutlineFileImage } from 'react-icons/ai'
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";

import NotesIcon from '../../../../assets/svg/notes-icon.svg'
import ChangeLogIcon from '../../../../assets/svg/changelog-icon.svg'
import { addSupplierHistory, downloadFileFromS3Bucket } from '../../../../redux/actions/vendor'
import { toast } from '../../../CommonComponents/ToastComponent/toast'
import AudioTranscript from '../../../CommonComponents/AudioTranscript';
import { capitalizeFirstCharacter } from '../../../../services/helper';
import EmailHistory from '../../../EmailHistory';
import { AppContext } from '../../../../context';
import ComposeEmail from '../../../ComposeEmail';

const MasterSupplierHistory = ({ historyTabs, callers }) => {
    const store = useStore().getState()
    const dispatch = useDispatch()
    const {
        getEmailsForListSupHandler,
        getRegisteredEmailsHandler,
        clearStates,
        showChildEmailHandler,
        handleToggle,
        parentEmailHistories,
        setParentEmailHistories,
        setChildEmailHistories,
        allHistories,
        isLoadingHistories,
        isLoadingEmailHistories,
        setIsSupplierHistoryCollapse,
        isSupplierHistoryCollapse,
        childEmailHistories,
        sortHistories,
        unreadEmails,
        categorizeEmail,
        actionOnEmail,
        reauthenticateModal,
        setReauthenticateModal,
        emailsToReauthenticate,
        googleTokensValidationHandler,
        googleLogin
    } = useContext(AppContext);
    const {
        vendor: {
            masterSupplierDetails,
        },
        user: {
            domainUsers,
            users
        },
        auth: {
            user
        }
    } = store

    const [hideEditorClass, setHideEditorClass] = useState('hide')
    const [editorState, setEditorState] = useState(() => EditorState.createEmpty());
    const [notes, setNotes] = useState([])
    const [changeLog, setChangeLog] = useState([])
    const [files, setFiles] = useState([])
    const [callRecordings, setCallRecordings] = useState([])
    const [allUnreadEmailCount, setAllUnreadEmailCount] = useState(0)
    const [activeTab, setActiveTab] = useState('notes')
    const [currentTab, setCurrentTab] = useState('all')

    const userSuggestion = []

    domainUsers && domainUsers.map((user) => {
        var text = user?.user?.firstname + (user?.user?.lastname ? ' ' + user?.user?.lastname : '')
        var value = user?.user?.email
        userSuggestion.push({ text: text, value: text, url: 'https://' + value })
    })

    useEffect(() => {
        if (!masterSupplierDetails || !masterSupplierDetails.supplierHistory) {
            return
        }
        if (!historyTabs) {
            return
        }
        let files = []
        let notes = (masterSupplierDetails?.supplierHistory.length > 0) ? masterSupplierDetails?.supplierHistory?.filter((history, ind) => history?.[ind].type === 'note') : []
        let changelog = (masterSupplierDetails?.supplierHistory.length > 0) ? masterSupplierDetails?.supplierHistory?.filter((history, ind) => history?.[ind].type === 'changelog') : []

        masterSupplierDetails?.paymentInfo?.achInstructions && files.push({ note: masterSupplierDetails?.paymentInfo?.achInstructions, createdDate: masterSupplierDetails?.paymentInfo?.updatedAt, fileType: 'ACH Payment Instructions File' })
        masterSupplierDetails?.cardInfo?.cardAuthorizationFormFile && files.push({ note: masterSupplierDetails?.cardInfo?.cardAuthorizationFormFile, createdDate: masterSupplierDetails?.cardInfo?.updatedAt, fileType: 'Card Authorization Form File' })

        setNotes(notes)
        setChangeLog(changelog)
        setFiles(files)
        setCallRecordings(masterSupplierDetails?.callRecordings)
    }, [masterSupplierDetails])

    const handleClickTab = (tab) => {
        setCurrentTab(tab)
    }

    const handleReplyEmailClose = async () => {
        if ((currentTab === 'all' || currentTab === 'email') && isSupplierHistoryCollapse) {
            const formattedHistory = masterSupplierDetails?.supplierHistory.map(obj => Object.values(obj)[0]);
            let tmpCallerRegisteredEmails = await getRegisteredEmailsHandler(callers)

            getEmailsForListSupHandler(user?.id, masterSupplierDetails?.contacts, formattedHistory, currentTab, tmpCallerRegisteredEmails)
        } else {
            clearStates()
        }
    }


    const panelHeader = (date = '', userId = null, isRecording = false, callType = '', callerId = null, isCallRecorded = false, callSid = '', phoneNo = '', emailHistory) => {
        let callerName = ''
        const userData = userId ? users?.find((user) => user?.id === userId) : null
        const userName = userData ? userData?.firstname + (userData?.lastname ? ' ' + userData?.lastname : '') : ''
        const dateObject = new Date(date)
        const month = dateObject.toLocaleString('default', { month: 'short' });
        const day = (dateObject.getDate() < 10) ? '0' + dateObject.getDate() : dateObject.getDate();
        const year = dateObject.getFullYear();
        const time = dateObject.toLocaleString('en-US', { hour: 'numeric', minute: 'numeric', hour12: true })
        const fullTime = month + ' ' + day + ',' + ' ' + year + ' ' + time;
        if (callerId) {
            const callerData = users?.find((user) => user?.id === callerId)
            callerName = callerData?.firstname + (callerData?.lastname ? ' ' + callerData?.lastname : '')
        }

        if (emailHistory?.messageId) {
            return (
                <EmailHistory
                    parentEmail={emailHistory}
                    key={emailHistory?.messageId}
                    contacts={masterSupplierDetails?.contacts}
                    handleReplyEmailClose={handleReplyEmailClose}
                    callerAssignedForEmail={user?.id}
                    showChildEmailHandler={showChildEmailHandler}
                    setAllUnreadEmailCount={setAllUnreadEmailCount}
                    callers={callers}
                    componentFor='masterSupplierDetails'
                />
            )
        } else {
            return <div className='d-flex align-items-center'>
                <p className='mb-0'> {isRecording ? `${capitalizeFirstCharacter(callType)} call ${callType === 'outbound' ? 'by' : 'to'}  ${callerName} at ` : ''} {fullTime} {phoneNo && <span className='text-black fw-normal'> - {phoneNo}</span>} {userName !== '' && <span> - {userName} </span>}</p>
            </div>
        }
    }

    const updateTextDescription = async (state) => {
        setHideEditorClass('')
        await setEditorState(state);
    };

    const handleCancelButton = () => {
        setEditorState(EditorState.createEmpty())
        setHideEditorClass('hide')
    }

    const onNotesSave = () => {
        const editorContent = draftToHtml(convertToRaw(editorState.getCurrentContent()));
        const isEmpty = convertToRaw(editorState.getCurrentContent()).blocks.every(block => block.text.trim() === '');
        if (!isEmpty) {
            dispatch(
                addSupplierHistory({
                    supplierId: masterSupplierDetails.baseInfo.id,
                    note: editorContent,
                    noteType: 'note',
                    supplierName: masterSupplierDetails?.baseInfo?.suppliername,
                    isMaster: masterSupplierDetails?.baseInfo?.isMaster
                })
            ).then(() => {
                setEditorState(EditorState.createEmpty())
                setHideEditorClass('hide')
            }).catch(() => {
                toast.show({
                    title: 'Warning',
                    description: 'Failed to add notes!',
                })
            })
        } else {
            toast.show({
                title: 'Warning',
                description: 'Please add note!',
            })
        }
    }

    const DownloadFile = (event) => {
        let currentFilename = event.currentTarget.dataset.filename
        dispatch(
            downloadFileFromS3Bucket({ filename: currentFilename })
        ).then((response) => {
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("download", currentFilename);
            document.body.appendChild(link);
            link.click();
            link.remove();
            toast.show({
                title: 'Success',
                description: currentFilename + ' downloaded successfully!',
            })
        }).catch(() => {
            toast.show({
                title: 'Warning',
                description: "Unable to Download File!",
            })
        })
    }

    const PanelHeader = (headerText) => {
        return (
            <h4 className='mb-0'> {headerText} </h4>
        )
    }

    useEffect(() => {
        if (!isSupplierHistoryCollapse) {
            setActiveTab('notes')
            setCurrentTab('all')
        }
    }, [isSupplierHistoryCollapse])

    useEffect(() => {
        if ((currentTab === 'all' || currentTab === 'email') && callers.length !== 0) {
            const formattedHistory = masterSupplierDetails?.supplierHistory.map(obj => Object.values(obj)[0]);
            getRegisteredEmailsHandler(callers).then((res) => {
                getEmailsForListSupHandler(user?.id, masterSupplierDetails?.contacts, formattedHistory, currentTab, res)
            }).catch(err => {
                toast.show({
                    title: 'danger',
                    description: "Unable To Get Registered Emails",
                })
            })
        }
    }, [currentTab, activeTab, isSupplierHistoryCollapse])

    const countUnreadEmailsHandler = (parentEmailHistories, childEmailHistories) => {
        let countUnreadEmails = 0

        for (let index = 0; index < [...parentEmailHistories, ...childEmailHistories].length; index++) {
            const email = [...parentEmailHistories, ...childEmailHistories][index];
            if (!email?.isRead) {
                countUnreadEmails++
            }
        }
        setAllUnreadEmailCount(countUnreadEmails)
    }

    useEffect(() => {
        const formattedHistory = masterSupplierDetails?.supplierHistory.map(obj => Object.values(obj)[0]);
        countUnreadEmailsHandler(parentEmailHistories, childEmailHistories)
        sortHistories(formattedHistory, parentEmailHistories);
    }, [parentEmailHistories, childEmailHistories]);

    const updateNewEmails = useCallback(async () => {
        let tmpCallerRegisteredEmails = await getRegisteredEmailsHandler(callers)
        const formattedHistory = masterSupplierDetails?.supplierHistory.map(obj => Object.values(obj)[0]);

        if (unreadEmails?.length === 0 && callers?.length !== 0) {
            await getEmailsForListSupHandler(user?.id, masterSupplierDetails?.contacts, formattedHistory, currentTab, tmpCallerRegisteredEmails)
        } else if (unreadEmails?.length !== 0 && callers?.length !== 0) {
            let tmpCallerRegEmailsOnly = tmpCallerRegisteredEmails?.map(regEmail => regEmail?.email?.toLowerCase())
            let tmpContactsEmailOnly = masterSupplierDetails?.contacts?.map((contact) => contact?.email?.toLowerCase())

            let tmpValidUnreadEmails = unreadEmails.filter((unreadEmail) =>
                tmpCallerRegEmailsOnly?.includes(unreadEmail?.receiverEmail?.toLowerCase()) &&
                tmpContactsEmailOnly?.includes(unreadEmail?.senderEmail?.toLowerCase())
            );

            setParentEmailHistories((prevParentEmails) => {
                const updatedEmailHistories = [...prevParentEmails, ...childEmailHistories, ...tmpValidUnreadEmails];
                const { parentEmails, childEmails } = categorizeEmail(updatedEmailHistories);

                setChildEmailHistories(childEmails);
                return parentEmails;
            });
        }
    }, [unreadEmails])

    useEffect(() => {
        updateNewEmails()
    }, [unreadEmails, updateNewEmails])

    const reauthenticateHandler = async () => {
        let tmpCallerRegisteredEmails = await getRegisteredEmailsHandler(callers)
        const formattedHistory = masterSupplierDetails?.supplierHistory.map(obj => Object.values(obj)[0]);

        googleLogin(true, user?.id, masterSupplierDetails?.contacts, formattedHistory, currentTab, tmpCallerRegisteredEmails, 'masterSupplierDetails')
        setReauthenticateModal(false)
    }

    useEffect(() => {
        googleTokensValidationHandler([user?.id])
    }, [])

    return (
        <Panel header={PanelHeader("Master Supplier History")} className=" card master-supplier-history-panel" collapsible bordered onSelect={() => { setIsSupplierHistoryCollapse(!isSupplierHistoryCollapse) }}>
            <div className='d-flex column-gap-4'>
                <button
                    className=' rounded-top fw-bold border'
                    style={{ backgroundColor: activeTab === 'email' ? 'white' : '#214466', color: activeTab === 'email' ? 'black' : 'white', width: 160, height: 40, fontSize: 16 }}
                    onClick={() => { setActiveTab('notes') }}
                >Note
                </button>
                <button
                    className='rounded-top fw-bold border'
                    style={{ backgroundColor: activeTab !== 'email' ? 'white' : '#214466', color: activeTab !== 'email' ? 'black' : 'white', width: 160, height: 40, fontSize: 16 }}
                    onClick={() => { setActiveTab('email') }}
                >
                    Email
                </button>
            </div>
            {reauthenticateModal && emailsToReauthenticate && <Modal backdrop={true} className="" show={reauthenticateModal} size="sm">
                <Modal.Header>
                    <h3 className="mb-0 fw-bold">Tokens Expired</h3>
                </Modal.Header>
                <Modal.Body className='p-0'>
                    <h4 className='p-0'>Your tokens are expired for <span className='fw-bold'>{emailsToReauthenticate}</span></h4>
                    <p className='fs-4 p-0'>Please re-authenticate again</p>
                </Modal.Body>
                <Modal.Footer >
                    <button className='report_button_secondary' onClick={reauthenticateHandler}>OK</button>
                </Modal.Footer>
            </Modal>}
            {activeTab === 'notes' && <div className="panel-content">
                <div className='supplier-history-editor-parent mt-3'>
                    <h3 className='fw-bold text-black'> Add Note </h3>
                    <Editor
                        editorState={editorState}
                        toolbarClassName={`supplier-history-editor-toolbar ${hideEditorClass}`}
                        wrapperClassName="supplier-history-editor-wrapper flex"
                        editorClassName="supplier-history-editor h5"
                        onEditorStateChange={updateTextDescription}
                        mention={{
                            separator: ' ',
                            trigger: '@',
                            suggestions: userSuggestion,
                        }}
                    />
                    <div className={`notes-editor-custom-buttons flex ${hideEditorClass}`}>
                        <button className='notes-cancel-button pt-2 pb-2  ps-2 pe-2 pt-sm-3 pb-sm-3 ps-sm-4 pe-sm-4 width-100' onClick={handleCancelButton}>Cancel</button>
                        <button className='notes-save-button pt-2 pb-2  ps-2 pe-2 pt-sm-3 pb-sm-3 ps-sm-4 pe-sm-4 width-100' onClick={onNotesSave}>Save</button>
                    </div>
                </div>
                <div className="page-tabs d-flex flex-column flex-sm-row">
                    {
                        historyTabs.map(tab => (
                            <button
                                key={tab.value}
                                type="button"
                                className={` flex align-items-center page-tab${currentTab === tab.value ? ' selected' : ''}`}
                                onClick={() => { handleClickTab(tab.value) }}
                            >
                                {tab.label}
                                {(tab?.value === 'email' || tab?.value === 'all') && allUnreadEmailCount > 0 && (!isLoadingEmailHistories || !isLoadingHistories) && <button className='rounded mx-2 d-flex align-items-center justify-content-center fs-4 text-white' style={{ width: 20, height: 20, backgroundColor: '#ff3333' }} >{allUnreadEmailCount}</button>}
                            </button>
                        ))
                    }
                </div>
                <div className='tabs-content'>
                    {currentTab === 'all' && (
                        <div className='tab-content'>
                            {isLoadingHistories ? <div className='text-center'><Loader /></div> :
                                (allHistories && currentTab === 'all' && allHistories.length > 0) ? allHistories.map((val, ind) => {
                                    return (
                                        <div key={ind} id={`${val?.callSid ? val?.callSid : val?.messageId}`} className='card d-flex flex-column flex-sm-row border-0'>
                                            <div>
                                                <div className='item-image-parent flex align-center justify-center'>
                                                    {(val.hasOwnProperty('isRecorded') && val?.isRecorded) ?
                                                        <IoRecordingOutline size={26} />
                                                        : (val.hasOwnProperty('messageId') && val?.messageId) ? <i class="bi bi-envelope fs-1"></i> :
                                                            <img className='item-image' src={NotesIcon} />
                                                    }
                                                </div>
                                                <div className='hor-line d-none d-sm-block'></div>
                                            </div>
                                            <div className='left-arrow'>
                                                <div className='top'></div>
                                                <div className='bottom'></div>
                                            </div>
                                            <Panel
                                                className="history-content"
                                                header={panelHeader(val?.hasOwnProperty('isRecorded') ? val?.callStartTime : val?.createdDate ? val?.createdDate : val?.sentDate, val?.userId, val?.hasOwnProperty('isRecorded') ? true : false, val?.callType || '', val?.hasOwnProperty('isRecorded') ? val?.callerAssigned : null, val?.isRecorded, val?.callSid, val?.callDetail?.externalNumber, val?.messageId ? val : null)}
                                                collapsible
                                                bordered
                                                defaultExpanded={val?.hasOwnProperty('isRecorded') ? false : true}
                                            // onSelect={() => { handleToggle(val?.domain === 'microsoft' ? val?.parentId : val?.messageId) }}
                                            >
                                                {val.hasOwnProperty('isRecorded') ? (
                                                    <>
                                                        {!val?.isRecorded && (
                                                            <h4 className='mb-0 fw-bold text-black'>Call not recorded due to state regulations</h4>
                                                        )}
                                                        <AudioTranscript
                                                            audioSrc={(val?.isRecorded && val?.callRecordingSid) ? `https://api.twilio.com/2010-04-01/Accounts/ACaefc30f519f53651b179eb9301f1c11a/Recordings/${val?.callRecordingSid}` : ''}
                                                            transcriptionSid={val?.callTranscriptionSid}
                                                            callType={val?.callType}
                                                        />
                                                    </>
                                                ) :
                                                    <div className='note-content h5'
                                                        dangerouslySetInnerHTML={{
                                                            __html: val.note
                                                        }}
                                                    />
                                                }
                                            </Panel>
                                        </div>
                                    )
                                }) : <p className='fs-4 text-center'>No History</p>
                            }
                        </div>
                    )}
                    {currentTab === 'notes' && (
                        <div className='tab-content'>
                            {(notes && notes.length > 0) ? notes.map((val, ind) => (
                                Object.values(val).map((value) => {
                                    return (
                                        <div key={ind} className='card d-flex flex-column flex-sm-row border-0'>
                                            <div>
                                                <div className='item-image-parent flex align-center justify-center'>
                                                    <img className='item-image' src={NotesIcon} />
                                                </div>
                                                <div className='hor-line d-none d-sm-block'></div>
                                            </div>
                                            <div className='left-arrow'>
                                                <div className='top'></div>
                                                <div className='bottom'></div>
                                            </div>
                                            <Panel className="history-content" header={panelHeader(value.createdDate, value.userId)} collapsible bordered defaultExpanded={true}>
                                                <div className='note-content h5'
                                                    dangerouslySetInnerHTML={{
                                                        __html: value.note
                                                    }}
                                                />
                                            </Panel>
                                        </div>
                                    )
                                })
                            )) :
                                <h4 className='no_data mb-0 ps-3 text-black fw-bold'> No data found. </h4>
                            }
                        </div>
                    )}
                    {currentTab === 'files' && (
                        <div className='tab-content'>
                            {(files && files.length > 0) ? files.map((val, ind) => (<div key={ind} className='card d-flex flex-column flex-sm-row border-0'>
                                <div>
                                    <div className='item-image-parent flex align-center justify-center'>
                                        <AiOutlineFileImage className='item-image' size={20} />
                                    </div>
                                    <div className='hor-line d-none d-sm-block'></div>
                                </div>
                                <div className='left-arrow'>
                                    <div className='top'></div>
                                    <div className='bottom'></div>
                                </div>
                                <Panel className="history-content" header={panelHeader(val.createdDate)} collapsible bordered defaultExpanded={true}>
                                    <div className='note-content h5'>
                                        <h4><b><em>{val.fileType}</em></b></h4>
                                        <div className='flex' style={{ marginTop: '10px' }}>
                                            <b>{val.note}</b>
                                            <FaDownload className="download-file" color="#65B3E9" size={20} data-filename={val.note} onClick={(event) => DownloadFile(event)} />
                                        </div>
                                    </div>
                                </Panel>
                            </div>
                            )) :
                                <h4 className='no_data mb-0 ps-3 text-black fw-bold'> No data found. </h4>
                            }
                        </div>
                    )}
                    {currentTab === 'changelog' && (
                        <div className='tab-content'>
                            {(changeLog && changeLog.length > 0) ? changeLog.map((val, ind) => (
                                Object.values(val).map((value) => {
                                    return (
                                        <div key={ind} className='card d-flex flex-column flex-sm-row border-0'>
                                            <div>
                                                <div className='item-image-parent flex align-center justify-center'>
                                                    <img className='item-image' src={ChangeLogIcon} />
                                                </div>
                                                <div className='hor-line d-none d-sm-block'></div>
                                            </div>
                                            <div className='left-arrow'>
                                                <div className='top'></div>
                                                <div className='bottom'></div>
                                            </div>
                                            <Panel className="history-content" header={panelHeader(value.createdDate, value.userId)} collapsible bordered defaultExpanded={true}>
                                                <div className='note-content h5'
                                                    dangerouslySetInnerHTML={{
                                                        __html: value.note
                                                    }}
                                                />
                                            </Panel>
                                        </div>
                                    )
                                })
                            )) :
                                <h4 className='no_data mb-0 ps-3 text-black fw-bold'> No data found. </h4>
                            }
                        </div>
                    )}
                    {currentTab === 'callRecordings' && (
                        <div className='tab-content'>
                            {callRecordings?.map((val, ind) => (
                                <>
                                    <div key={ind} className='card d-flex flex-column flex-sm-row border-0'>
                                        <div>
                                            <div className='item-image-parent flex align-center justify-center'>
                                                <IoRecordingOutline size={26} />
                                            </div>
                                            <div className='hor-line d-none d-sm-block'></div>
                                        </div>
                                        <div className='left-arrow'>
                                            <div className='top'></div>
                                            <div className='bottom'></div>
                                        </div>
                                        <Panel className="history-content" header={panelHeader(val.callStartTime, val.userId, true, val?.callType || '', val?.callerAssigned, val?.isRecorded, val?.callSid, val?.callDetail?.externalNumber)} collapsible bordered defaultExpanded={false}>
                                            {!val?.isRecorded && (
                                                <h4 className='mb-0 fw-bold text-black'>Call not recorded due to state regulations</h4>
                                            )}
                                            <AudioTranscript
                                                audioSrc={(val?.isRecorded && val?.callRecordingSid) ? `https://api.twilio.com/2010-04-01/Accounts/ACaefc30f519f53651b179eb9301f1c11a/Recordings/${val?.callRecordingSid}` : ''}
                                                transcriptionSid={val?.callTranscriptionSid}
                                                callType={val?.callType}
                                            />
                                        </Panel>
                                    </div>
                                </>
                            ))}
                        </div>
                    )}
                    {currentTab === 'email' && (
                        <div className='tab-content'>
                            {isLoadingEmailHistories ? <div className='text-center'><Loader /></div> :
                                parentEmailHistories?.length > 0 ? parentEmailHistories.sort((a, b) => new Date(b?.sentDate) - new Date(a?.sentDate))?.map((val, ind) => {
                                    return (
                                        <div key={val?.messageId} id={`${val?.messageId}`} className='card d-flex flex-column flex-sm-row border-0'>
                                            <div>
                                                <div className='item-image-parent flex align-center justify-center'>
                                                    <i class="bi bi-envelope fs-1"></i>
                                                </div>
                                                <div className='hor-line d-none d-sm-block'></div>
                                            </div>
                                            <div className='left-arrow'>
                                                <div className='top'></div>
                                                <div className='bottom'></div>
                                            </div>
                                            <Panel
                                                className="history-content"
                                                header={panelHeader(val?.sentDate, user?.id, false, '', null, null, null, null, val)}
                                                collapsible
                                                bordered
                                                onSelect={() => { handleToggle(val?.domain === 'microsoft' ? val?.parentId : val?.messageId) }}
                                            ></Panel>
                                        </div>
                                    )
                                }) : <p className='text-center fs-4'>No Emails</p>
                            }
                        </div>
                    )}

                </div>
            </div>}
            {
                activeTab === 'email' && (
                    <ComposeEmail
                        componentFor={'masterSupplierDetail'}
                        actionOnEmail={actionOnEmail}
                        supplierInfo={{}}
                        vendorInfo={{}}
                        contactOptions={[]}
                        onGetExistingContacts={() => { }}
                        vendorInCallDetailsId={null}
                        contacts={masterSupplierDetails?.contacts}
                        getContactsData={() => { }}
                        activeTab={activeTab}
                    />
                )
            }
        </Panel>
    )
}

export default MasterSupplierHistory
